import {ENV_CONFIGS} from '../constants/envs';

const getOSSObjectURL = (bucketKey, ossObjectURN) =>
  `${ENV_CONFIGS.APIGEE_HOST}/oss/v2/buckets/${bucketKey}/objects/${ossObjectURN}`;

const URN_REGEX = /^urn:[\w.:]+:([^:/]+)\/([^/]+)$/;
/**
 * Gets the URL of a file stored in the OSS service from its URN.
 * @example const url = getOSSObjectURLFromURN('urn:adsk.objects:os.object:wip.dm.qa/8b2fbc08-d506-4412-a1dd-6004d058da06.pdf')
 * assert.equal(
 *   url,
 *   'https://developer-stg.api.autodesk.com/oss/v2/buckets/wip.dm.qa/objects/8b2fbc08-d506-4412-a1dd-6004d058da06.pdf')
 * @param {string} urn
 * @returns {string}
 */
export const getOSSObjectURLFromURN = urn => {
  const [, bucketKey, ossObjectURN] = urn.match(URN_REGEX) || [];
  return getOSSObjectURL(bucketKey, ossObjectURN);
};
